<!-- Sales Information -->
<nz-skeleton
  [ngClass]="loading ? 'mt-4' : 'mt-0'"
  [nzLoading]="loading"
  [nzActive]="true"
>
  <div class="mt-4">
    <span><b>Sales Information</b></span>
    <div class="d-flex mt-2 table-responsive">
      <table class="table table-hover" responsive>
        <thead>
          <tr>
            <th scope="col">NO</th>
            <th scope="col">PRODUCT NAME</th>
            <th scope="col">UNIT PRICE</th>
            <th scope="col">TOTAL</th>
            <th scope="col">SUB TOTAL</th>
          </tr>
        </thead>
        <tbody *ngFor="let item of orderDetails; let i = index">
          <tr>
            <td>{{ i + 1 }}</td>
            <td>{{ item.product_name }}</td>
            <td>{{ item.product_price | idr }}</td>
            <td>{{ item.qty }}</td>
            <td>{{ item.subtotal | idr }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</nz-skeleton>

<!-- Notes -->
<nz-skeleton
  [ngClass]="loading ? 'mt-4' : 'mt-0'"
  [nzLoading]="loading"
  [nzActive]="true"
>
  <div class="mt-4">
    <span><b>Notes</b></span>
    <div
      class="d-flex p-3 mt-2"
      style="border: 1px solid; border-color: grey; border-radius: 5px"
    >
      <div class="">
        <p style="color: grey">No Notes</p>
      </div>
    </div>
  </div>
</nz-skeleton>

<!-- Price Summary -->
<nz-skeleton
  [ngClass]="loading ? 'mt-4' : 'mt-0'"
  [nzLoading]="loading"
  [nzActive]="true"
>
  <div class="">
    <div class="row d-flex mt-4 justify-content-between">
      <div class="col-12 d-flex justify-content-end">
        <div class="col-4 text-align-start">
          <p>Total Product Price</p>
          <p>Shipping Cost</p>
          <p>Additional Cost</p>
        </div>
        <div class="col-2 tharga text-align-end">
          <p>{{ totalPrice | idr }}</p>
          <p>{{ detailOrder.shipping_cost | idr }}</p>
          <p>{{ detailOrder.additional_cost | idr }}</p>
        </div>
      </div>
    </div>
    <div class="row d-flex justify-content-between garis">
      <div class="col d-flex justify-content-end text-align-start">
        <div class="col-6">
          <hr />
        </div>
      </div>
    </div>
    <div class="row d-flex justify-content-between">
      <div class="col-12 d-flex justify-content-end">
        <div class="col-4 COD text-align-start">
          <b
            [style]="
              detailOrder.order_status === 'Retur'
                ? 'text-decoration: line-through'
                : ''
            "
            >Total Payment ({{ detailOrder.payment_method }})</b
          >
        </div>
        <div class="col-2 hCOD text-align-end">
          <b
            [style]="
              detailOrder.order_status === 'Retur'
                ? 'text-decoration: line-through'
                : ''
            "
            >{{ detailOrder.grand_total | idr }}</b
          >
        </div>
      </div>
    </div>
    <nz-collapse nzGhost nzExpandIconPosition="end">
      <nz-collapse-panel
        [nzHeader]="headerTpl"
        [nzActive]="!isCollapsed"
        (nzActiveChange)="isCollapsed = !$event"
      >
        <div class="row d-flex justify-content-between">
          <div class="col-12 d-flex justify-content-end">
            <div class="col-4 text-align-start diskon">
              <p *ngIf="detailOrder.order_status !== 'Retur'">
                COD fee ( 2.8% including VAT)
              </p>
              <p *ngIf="detailOrder.order_status === 'Retur'">
                Cod fee ( 0% including VAT)
              </p>
              <p>Shipping Cost (after Cashback -)</p>
              <p
                *ngIf="
                  detailOrder.payment_method === 'BANK TRANSFER' &&
                  detailOrder.order_status === 'Retur'
                "
              >
                Return Shipping Costs (after Cashback -)
              </p>
              <p *ngIf="detailOrder.is_insurance !== 0">Insurance Fee</p>
              <p>Discount</p>
              <p *ngIf="detailOrder.shipping === 'GOSEND'">Price Difference</p>
            </div>
            <div class="col-2 tharga">
              <p *ngIf="detailOrder.order_status !== 'Retur'">
                -{{ detailOrder.service_fee | idr }}
              </p>
              <p *ngIf="detailOrder.order_status === 'Retur'">{{ 0 | idr }}</p>
              <p
                *ngIf="
                  detailOrder.payment_method === 'BANK TRANSFER' &&
                  detailOrder.order_status === 'Retur'
                "
              >
                -{{
                  detailOrder.shipping_cost - detailOrder.shipping_cashback
                    | idr
                }}
              </p>
              <p>
                -{{
                  detailOrder.shipping_cost - detailOrder.shipping_cashback
                    | idr
                }}
              </p>
              <p *ngIf="detailOrder.is_insurance !== 0">
                -{{ detailOrder.insurance_value || 0 | idr }}
              </p>
              <p>
                -{{ detailOrder.discount || 0 | idr }}
              </p>
              <p *ngIf="detailOrder.shipping === 'GOSEND'">
                {{ detailOrder.gosend_price_difference || 0 | idr }}
              </p>
            </div>
          </div>
        </div>
      </nz-collapse-panel>
    </nz-collapse>

    <ng-template #headerTpl>
      <div class="row mt-1 d-flex justify-content-between garis w-100 m-0">
        <div
          class="col-12 d-flex justify-content-end text-align-end align-items-center p-0"
        >
          <div class="col-5 text-align-start">
            <hr />
          </div>
          <div class="col-1 d-flex justify-content-end text-align-end pe-0">
            <div class="flex items-center gap-1 btn-open text-dark">
              @if (isCollapsed) {
                <span>Open</span>
              }
              @if (!isCollapsed) {
                <span>Close</span>
              }
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <div class="row d-flex justify-content-between">
      <div
        class="col-12 d-flex justify-content-end text-align-start net-total"
      >
        <div class="col-4">
          <b>Net Income</b>
        </div>
        @if (detailOrder.order_status !== 'Retur') {
          <div class="col-2 net text-align-end">
            <b>{{
              detailOrder.grand_total -
                detailOrder.service_fee -
                (detailOrder.shipping_cost - detailOrder.shipping_cashback) -
                detailOrder.insurance_value | idr
            }}</b>
          </div>
        }
        @if (detailOrder.order_status === 'Retur' && detailOrder.payment_method !== 'BANK TRANSFER') {
          <div class="col-2 net-lost text-align-end">
            <b>
              -{{
                detailOrder.shipping_cost -
                  detailOrder.shipping_cashback +
                  detailOrder.insurance_value | idr
              }}</b
            >
          </div>
        }
        @if (detailOrder.order_status === 'Retur' && detailOrder.payment_method === 'BANK TRANSFER') {
          <div class="col-2 net-lost text-align-end">
            <b>
              -{{
                (detailOrder.shipping_cost - detailOrder.shipping_cashback) *
                  2 +
                  detailOrder.insurance_value | idr
              }}</b
            >
          </div>
        }
      </div>
    </div>
  </div>
</nz-skeleton>
